import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Carousel } from 'react-responsive-carousel';

import { firebaseStorage } from '../../../utils/firebase';
import styles from './styles';

class FirebaseCarousel extends React.Component {
  static propTypes = {
    images: PropTypes.array.isRequired,
  };

  state = {
    loading: true,
    images: [],
  };

  componentWillMount() {
    Promise.all(this.props.images.map((image) => {
      return firebaseStorage.ref(image.path)
        .getDownloadURL()
        .then((url) => _.assign({}, image, { url }));
    })).then((images) => {
      this.setState({
        images,
        loading: false,
      });
    });

  }

  render() {
    const { images } = this.state;
    if (this.state.loading) {
      return <img src="/images/loading.gif" style={styles.loading} alt="img"/>;
    }

    return (
      <Carousel showArrows dynamicHeight>
        {images.map((image) => (<div key={image.id}>
          <img src={image.url} alt="img" style={{maxHeight: 500, maxWidth: 600 }}/>
          {image.stage || image.by ? <p className="legend">
            {image.stage ? <div>{image.stage.name}</div> : null}
            {image.by ? <div>{image.by.name}</div> : null}
          </p> : null}
        </div>))}
      </Carousel>

    );
  }
}

export default FirebaseCarousel;



// WEBPACK FOOTER //
// ./src/components/Common/FirebaseCarousel/index.js